import { render, staticRenderFns } from "./AccessibilityPanel.vue?vue&type=template&id=716d3ef4&scoped=true&"
import script from "./AccessibilityPanel.vue?vue&type=script&lang=js&"
export * from "./AccessibilityPanel.vue?vue&type=script&lang=js&"
import style0 from "./AccessibilityPanel.vue?vue&type=style&index=0&id=716d3ef4&lang=scss&scoped=true&"
import style1 from "./AccessibilityPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716d3ef4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716d3ef4')) {
      api.createRecord('716d3ef4', component.options)
    } else {
      api.reload('716d3ef4', component.options)
    }
    module.hot.accept("./AccessibilityPanel.vue?vue&type=template&id=716d3ef4&scoped=true&", function () {
      api.rerender('716d3ef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AccessibilityPanel.vue"
export default component.exports